import { render, staticRenderFns } from "./Old.vue?vue&type=template&id=2c44cc0f&scoped=true"
import script from "./Old.vue?vue&type=script&lang=js"
export * from "./Old.vue?vue&type=script&lang=js"
import style0 from "./Old.vue?vue&type=style&index=0&id=2c44cc0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44cc0f",
  null
  
)

export default component.exports